import type { Question, StatefulRecommendedQuestion } from './App/state';

/** Questions Updated Alert Panel ID */
const questionsUpdatedId = 'alert-questions-updated';

/** Question */
const questionPanelId = (
  question: Question | StatefulRecommendedQuestion,
): string => question.id;

export { questionsUpdatedId, questionPanelId };
